<template>
  <div :class="$style.container" style="opacity: 0;">
    <transition @enter="enter" @leave="leave" :css="false">
      <form
        action=""
        :class="$style.form"
        key="form"
        v-if="!sended"
      >
        <div :class="[$style.inputContainer, status.email ? $style[status.email] : false]">
          <p v-if="errors.has('email')">{{ global.newsletter.error.email }}</p>
          <input 
            v-validate="'required|email'"
            @focus="handleFocus" type="text" name="email" 
            v-model="email"
            :placeholder="global.newsletter.placeholder.email"/>
        </div>

        <div :class="$style.submitContainer">
          <Cta :class="$style.submit" type="submit" @click.native="submitForm">Subscribe</Cta>
        </div>
      </form>

      <div :class="$style.thxMsg" v-if="sended && thx" key="thx">
        <p v-html="global.newsletter.thxMsg"></p>
      </div>
    </transition>
  </div>
</template>

<script>
import gsap from 'gsap'
import { mapState } from 'vuex'
import Cta from '@/components/Cta'

export default {
  props: ['content', 'setSubscribe', 'thx'],

  computed: {
    ...mapState(['global'])
  },

  components: {
    Cta
  },

  data() {
    return {
      focused: false,
      email: '',
      status: {
        email: false,
      },

      sended: false
    }
  },

  methods: {
    handleFocus(e) {
      if (this.focused) this.status[this.focused] = false
      this.focused = e.target.name
      this.status[e.target.name] = 'focus'
    },

    submitForm(event) {
      event.preventDefault()

      this.$validator.validateAll().then((result) => {
        if (result) {
          // eslint-disable-next-line
          const createData = {
            email: this.email
          }

          this.$store.dispatch('SEND_NEWSLETTER', createData).then((res) => {
            if (res.response) {
              this.sended = true;

              this.setSubscribe('sent');
            }
          })
        }
      })
    },

    enter(el, done) {
      gsap.to(el, 1, {
        startAt: {
          y: 100
        },
        autoAlpha: 1,
        y: 0,
        ease: gsap.Expo.easeOut,
        onComplete: done
      })
    },

    leave(el, done) {
      gsap.to(el, 1, {
        autoAlpha: 0,
        y: -200,
        ease: gsap.easeOut,
      })
    }
  }
}
</script>

<style module lang="scss">
@import "~sass-mq/mq";

.container {
  position: absolute;
  width: 100%;
  bottom: 0;
  
  padding: 30px;

  background: $color-dark-two;

  @include mq(sm) {
    padding: 20px 60px 40px;
  }
}

input,
textarea {
  background: transparent;
  border: 0;
  width: 100%;
  padding: 20px;

  &:focus {
    outline: none;
  }
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  border: 0px;
  -webkit-text-fill-color: $color-white;
  -webkit-box-shadow: 0 0 0px 1000px #000 inset;
  transition: background-color 5000s ease-in-out 0s;
}

.form {
  position: relative;
  display: flex;
  flex-flow: row wrap;
}

.inputContainer {
  position: relative;
  margin-bottom: 20px;
  width: 100%;
  flex: 0 0 auto;

  @include mq(sm) {
    flex: 1 0 0;
    margin-bottom: 0;
    margin-right: rem(60px);
  }

  p {
    position: absolute;
    top: 100%;
    color: $color-blue;
    font-size: font-size(s);
    padding-top: 5px;
  }

  &.focus {
    &::after {
      transform: scale(1, 1);
    }
  }

  &.fullWidth {
    width: 100%;
  }

  &::after,
  &::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background: $color-gray-brown;
    transition: all 0.3s ease-out;
  }

  &::after {
    z-index: 1;
    background: white;
    transform-origin: 0;
    transform: scale(0, 1);
  }

  &.privacy {
    &::before,
    &::after {
      content: none;
    }

    input {
      @include visually-hidden;

      &:checked + .fakeInput {
        background: $color-gray-brown;
      }
    }

    label {
      cursor: pointer;
      font-size: font-size(s);

      color: $color-gray-brown;

      .fakeInput {
        display: inline-block;
        width: 12px;
        height: 12px;
        margin: 0 4px 0 0;
        
        border: 1px solid $color-gray-brown;
        vertical-align: baseline;
      }
    }
  }
}

.submitContainer {
  width: 100%;
  display: flex;

  button {
    width: 100%;
    margin: 0;
  }

  @include mq(sm) {
    flex: 0 1 0;

    button {
      display: inline-block;
      padding: 20px 50px;
      width: auto;
    }
  }
}

input
textarea {
  @include placeholder() {
    color: $color-gray-brown;
  }
}

.thxMsg {
  bottom: 40px;
  position: absolute;

  color: $color-blue;

  @include mq(sm) {
    // top: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NewsletterForm.vue